import { useEffect, useState } from 'react';
import { getCartsTimers } from '../services/ace';

type Timer = {
  id: number;
  uuid: string;
  name: string;
  startTime: string;
  endTime: string;
  isActive: boolean;
  autoBillDate: string;
  tiers: string[];
};

type CartUpgradeResult = 'maintained' | 'shelved' | 'dumped';

const getActiveTimerId = (timers: Timer[]) => timers.find((timer) => timer.isActive)?.id || null;

const getUpgradeCartResult = (
  currentTimerId: number | null,
  goldTimerId: number | null,
): CartUpgradeResult => {
  if (!currentTimerId && !goldTimerId) return 'maintained';
  if (!currentTimerId && goldTimerId) return 'shelved';
  if (currentTimerId && !goldTimerId) return 'dumped';
  return 'maintained';
};

const useCartTimers = () => {
  const [loadingCartTimers, setLoadingCartTimers] = useState(true);
  const [cartUpgradeResult, setCartUpgradeResult] = useState<CartUpgradeResult | null>(null);

  useEffect(() => {
    Promise.all([getCartsTimers(), getCartsTimers('GOLD')]).then(([currentTimer, goldTimer]) => {
      const currentTimerId = getActiveTimerId(currentTimer);
      const goldTimerId = getActiveTimerId(goldTimer);
      const upgradeCartResult = getUpgradeCartResult(currentTimerId, goldTimerId);
      setLoadingCartTimers(false);
      setCartUpgradeResult(upgradeCartResult);
    });
  }, []);

  return { loadingCartTimers, cartUpgradeResult };
};

export default useCartTimers;
